import { render, staticRenderFns } from "./CourseNavSteps.vue?vue&type=template&id=38f6584b&scoped=true"
import script from "./CourseNavSteps.vue?vue&type=script&lang=js"
export * from "./CourseNavSteps.vue?vue&type=script&lang=js"
import style0 from "./CourseNavSteps.vue?vue&type=style&index=0&id=38f6584b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6584b",
  null
  
)

export default component.exports